class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    const scripts = this.querySelectorAll('safe-load-scripts > script');
    const registry = window.wetheme?.webcomponentRegistry;
    
    scripts.forEach((script) => {
      const key = script.dataset.flowLoadKey;
      const scriptLoaded = registry?.checkScriptLoaded(key);
      
      if (!scriptLoaded) {
        const postLoadedScript = document.createElement('script');
        const {src, defer, async, type} = script;
        
        // Copy over attributes
        if (src) postLoadedScript.src = src;
        if (defer) postLoadedScript.defer = defer;
        if (async) postLoadedScript.async = async;
        if (type) postLoadedScript.type = type;
        
        // Handle inline scripts
        if (!src && script.textContent) {
          postLoadedScript.textContent = script.textContent;
        }
        
        // Add load handler for both inline and external scripts
        postLoadedScript.onload = () => {
          if (typeof window.initSizeGuide === 'function') {
            window.initSizeGuide();
          }
        };
        
        this.parentElement.appendChild(postLoadedScript);
        
        // Register script as loaded
        if (registry && typeof registry.registerScriptAsLoaded === 'function') {
          registry.registerScriptAsLoaded(key);
        }
      } else {
        // Call initSizeGuide even for already loaded scripts
        if (typeof window.initSizeGuide === 'function') {
          window.initSizeGuide();
        }
      }
    });
  }
}

customElements.define('safe-load-scripts', SafeLoadScripts);